import service from './request'

/**
 * 获取客户公司列表信息
 */
 export const cusCompanyGetList = data => {
  return service({
      showLoading: true,
      url: '/crm/cusCompany/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取客户公司信息
 */
 export const cusCompanyGetInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/cusCompany/getInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 添加客户公司信息
 */
 export const cusCompanyAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/cusCompany/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改客户公司信息
 */
 export const cusCompanyUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/cusCompany/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除客户公司信息
 */
 export const cusCompanyDelInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/cusCompany/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取公司变更信息
 */
 export const cusCompanyChangeRecGetList = data => {
  return service({
      showLoading: false,
      url: '/crm/cusCompany/changeRec/getList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取公司客户信息
 */
 export const cusCompanyGetCustomerList = data => {
  return service({
      showLoading: false,
      url: '/crm/cusCompany/getCustomerList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取客户公司工单信息
 */
 export const cusCompanyGetOrderList = data => {
  return service({
      showLoading: false,
      url: '/crm/cusCompany/getOrderList',
      method: 'post',
      type: 'body',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/cusCompanyManagement.js